import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconPersons = ({ color = 'currentColor', size = 'micro', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" size={size} {...props}>
        <StyledStrokedGroup color={color} strokeLinecap="round" strokeLinejoin="round">
            <StyledPath
                d="M2.8125 6.5625C2.8125 7.47418 3.17466 8.34852 3.81932 8.99318C4.46398 9.63784 5.33832 10 6.25 10C7.16168 10 8.03602 9.63784 8.68068 8.99318C9.32534 8.34852 9.6875 7.47418 9.6875 6.5625C9.6875 5.65082 9.32534 4.77648 8.68068 4.13182C8.03602 3.48716 7.16168 3.125 6.25 3.125C5.33832 3.125 4.46398 3.48716 3.81932 4.13182C3.17466 4.77648 2.8125 5.65082 2.8125 6.5625Z"
                color="none"
            />
            <StyledPath
                d="M0.625 16.875C0.625 15.3832 1.21763 13.9524 2.27252 12.8975C3.32742 11.8426 4.75816 11.25 6.25 11.25C7.74184 11.25 9.17258 11.8426 10.2275 12.8975C11.2824 13.9524 11.875 15.3832 11.875 16.875"
                color="none"
            />
            <StyledPath
                d="M11.8758 3.68004C12.3949 3.34278 12.9954 3.15193 13.6139 3.12765C14.2324 3.10336 14.846 3.24654 15.3899 3.54207C15.9338 3.8376 16.3878 4.27451 16.704 4.80667C17.0202 5.33883 17.1868 5.94649 17.1862 6.56548C17.1857 7.18448 17.018 7.79185 16.7009 8.32346C16.3838 8.85507 15.9291 9.29119 15.3847 9.58577C14.8403 9.88036 14.2264 10.0225 13.6079 9.99712C12.9894 9.97176 12.3893 9.77987 11.8708 9.44171"
                color="none"
            />
            <StyledPath
                d="M12.5 11.3892C13.3238 11.2025 14.179 11.2036 15.0023 11.3924C15.8256 11.5811 16.596 11.9526 17.2562 12.4795C17.9164 13.0063 18.4497 13.6749 18.8165 14.4358C19.1832 15.1967 19.3741 16.0303 19.375 16.875"
                color="none"
            />
        </StyledStrokedGroup>
    </StyledSvg>
);
